module.exports = __webpack_public_path__ + "img/home-grey.106e7b9a.svg";